module.exports = __webpack_public_path__ + "static/media/hunter-and-shadow.fc770e6b.png";